export interface Config {
  baseUrl: string;
  keycloak: {
    baseUrl: string;
    realm: string;
    client: string;
  };
  api: {
    baseUrl: string;
  };
  environment: string;
  sentry: {
    enabled: boolean;
  };
}

let configCache: Config | null = null;

export async function getConfig(): Promise<Config> {
  if (configCache) {
    return configCache;
  }

  try {
    const response = await fetch("/config.json");
    if (!response.ok) {
      throw new Error(`Failed to fetch config: ${response.status}`);
    }

    configCache = (await response.json()) as Config;
    return configCache;
  } catch (error) {
    console.error("Error loading config:", error);
    throw new Error("Failed to load application configuration");
  }
}
